// Career Launch 학생 화면 공용 배경 자리.
// v2(흰 바탕 토스 스타일)에선 오로라·그라데이션을 쓰지 않는다 — 흰 바탕 그대로 두고 아무것도 그리지 않는다.
// 호출하는 화면(루트 `isolate` + 첫 자식)은 그대로 두어도 되도록 컴포넌트는 남겨 둔다.
export function LaunchAmbientBackground() {
  return null;
}
